import { render, staticRenderFns } from "./ModelCustomerCustomRequestSubmit.vue?vue&type=template&id=519cd9ac&scoped=true"
import script from "./ModelCustomerCustomRequestSubmit.vue?vue&type=script&lang=js"
export * from "./ModelCustomerCustomRequestSubmit.vue?vue&type=script&lang=js"
import style0 from "./ModelCustomerCustomRequestSubmit.vue?vue&type=style&index=0&id=519cd9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cd9ac",
  null
  
)

export default component.exports